import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Modal,
  Switch,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import clsx from "clsx";
import _ from "lodash";
import PropTypes from "prop-types";
import React, { useState } from "react";

import { useModalStyles } from "./modalStyles";
import "react-datetime/css/react-datetime.css";
import "../../../theme/custom.css";

export const DestinationSettingsModal = ({
  open,
  onClose,
  onSave,
  settings,
}) => {
  const classes = useModalStyles();

  const [settingsToUpdate, setSettingsToUpdate] = useState({});

  if (!open) {
    return null;
  }

  function addSetting(key, value) {
    const newSettingsToUpdate = _.extend({}, settingsToUpdate, {
      [key]: value,
    });
    setSettingsToUpdate(newSettingsToUpdate);
  }

  function lookupSetting(key) {
    if (key in settingsToUpdate) {
      return settingsToUpdate[key];
    }

    return settings[key];
  }

  function handleSave() {
    onClose();
    onSave(settingsToUpdate);
    setSettingsToUpdate({});
  }

  function handleClose() {
    onClose();
    setSettingsToUpdate({});
  }

  return (
    <Modal onClose={onClose} open={open}>
      <Card className={clsx(classes.root)}>
        <CardHeader
          title="Event Destinations: Advanced Settings"
          classes={{ action: clsx(classes.closeIconAction) }}
          action={<CloseIcon onClick={onClose} />}
        />
        <Divider />
        <CardContent>
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={9}>
              <Typography variant="body1">
                <span className={clsx(classes.bold)}>
                  Override hardcoded destinations?
                </span>
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Switch
                checked={!lookupSetting("segmentCompatible")}
                color="secondary"
                name="enable-destination-for-event"
                onChange={() =>
                  addSetting(
                    "segmentCompatible",
                    !lookupSetting("segmentCompatible")
                  )
                }
                value={!lookupSetting("segmentCompatible")}
              />
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <CardActions className={classes.actions}>
          <Button onClick={() => handleClose()}>CLOSE</Button>

          <Button
            onClick={() => handleSave()}
            variant="contained"
            color="primary"
          >
            Save
          </Button>
        </CardActions>
      </Card>
    </Modal>
  );
};

DestinationSettingsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  settings: PropTypes.object.isRequired,
};
